"use client"
import { useEffect, useState } from "react";
import { PersianNum } from "../tools";

interface Props {
    callback: (a: boolean) => void;
    minute: number;
    second: number;
    start: boolean;
}

const OtpTimer = ({ callback, minute = 0, second = 0, start }: Props) => {
    const [minutes, setMinutes] = useState(minute);
    const [seconds, setSeconds] = useState(second);
    const StartTimer = () => {
        if (start) {
            setMinutes(minute);
            setSeconds(second);
            callback(false);
        }
    };
    useEffect(() => {
        const myInterval = setInterval(() => {
            if (seconds > 0) {
                setSeconds(seconds - 1);
            }
            if (seconds === 0) {
                if (minutes === 0) {
                    callback(true);
                    clearInterval(myInterval);
                } else {
                    setMinutes(minutes - 1);
                    setSeconds(59);
                }
            }
        }, 1000);
        return () => {
            clearInterval(myInterval);
        };
    });

    return (
        <>
            {minutes === 0 && seconds === 0 ? (
                <span style={{ cursor: "pointer" }} onClick={() => StartTimer()}>
                    ارسال دوباره
                </span>
            ) : (
                <span>
                    شما {" "} -
                    {PersianNum(minutes)}:
                    {second < 10 ? `0${PersianNum(seconds)}` : PersianNum(seconds)}
                    {" "} - زمان دارید برای وارد کردن کد
                </span>
            )}
        </>
    );
};

export default OtpTimer;
